// Alias legado — código novo deve usar useStore.
// TODO: deprecar após páginas antigas migrarem.

import { useStoreContext } from '../contexts/StoreContext';

export const useSupplier = () => {
  const { store, loading, error, isReviterSite, isStoreSite } = useStoreContext();
  return {
    supplier: store,       // apelido legado
    store,                 // forma nova
    loading,
    error,
    isSupplierSite: isStoreSite,
    isStoreSite,
    isReviterSite
  };
};

export default useSupplier;
